export default __webpack_public_path__ + "static/favicon-4e82b3534e37ca0c592f0c52c2948b2e.jpg";